import styled, { css } from 'styled-components';

import theme from '@theme';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  & > .searchbar__innerWrapper {
    box-shadow: 0px 0px 8px 0px rgba(0, 17, 68, 0.08);
  }
`;

export const TabWrapper = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.white};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

export const TabItemWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  padding: 24px 12px;
  color: white;
  min-height: 180px;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    padding: 24px;
  }
`;

export const TabMenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 17px;
  font-weight: 600;
  background-color: ${({ theme }) => theme.palette.white};
  border-bottom: ${({ theme }) => `0.5px solid ${theme.palette.grey500}`};
  overflow-x: auto;
  white-space: nowrap;
  scroll-behavior: smooth;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Safari ve Chrome */
  }

  @media (max-width: ${theme.breakPoint.LARGE_1X}) {
    padding-left: 0;
  }

  padding-left: 20px;
`;

export const TabMenuScroll = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: -56px;
  z-index: 99999;
`;

export const ScrollButtonLeft = styled.div`
  height: 55px;
  width: 30px;
  background-color: ${({ theme }) => theme.palette.primaryBrand};
  cursor: pointer;
  text-align: center;
  padding-top: 17px;
  color: white;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
`;

export const ScrollButtonRight = styled.div`
  height: 55px;
  width: 30px;
  background-color: ${({ theme }) => theme.palette.primaryBrand};
  cursor: pointer;
  text-align: center;
  padding-top: 17px;
  color: white;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
`;

export const TabMenuItem = styled.div<{ isActive: boolean }>`
  display: flex;
  flex-direction: row;
  background-color: ${({ isActive }) => (isActive ? '#434343CC' : '#ebebeb')};
  color: ${({ isActive }) => (isActive ? '#fff' : '#434343 ')};
  width: 175px;
  height: 54px;
  padding: 14px 24px 12px 24px;
  font-size: 17px;
  font-weight: 600;
  :hover {
    background-color: #434343;
    color: #fff;
    cursor: pointer;
  }
`;

export const IconWrapper = styled.div<{ rotate?: boolean }>`
  margin: 0px 10px 0px 20px;
  transform: ${({ rotate }) => (rotate ? 'rotate(45deg)' : 'none')};
`;

export const TextWrapper = styled.div`
  :hover {
    color: #fff;
  }
`;

export const TabItemSubWrapper = styled.div``;

export const SearchBarInputStyles = css`
  box-shadow: none;
  border-color: ${({ theme }) => theme.palette.inputBorderColor};
  border-radius: 4px;

  .setur-input {
    color: ${({ theme }) => theme.palette.grey1100} !important;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;

    ::placeholder,
    ::-webkit-input-placeholder {
      color: ${({ theme }) => theme.palette.grey800} !important;
    }
  }

  &.setur-input-affix-wrapper-focused,
  &:hover {
    border-color: ${({ theme }) => theme.palette.black} !important;
  }
`;
